module.exports = __webpack_public_path__ + "static/img/img_ser_nofounder.12d8133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_ser_nofounder.png
// module id = 1fkB
// module chunks = 1